/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import './app.css'
// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SignIn from "layouts/authentication/sign-in";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React example components
import Sidenav from "components/Sidenav";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import Alert from "components/alert/alert";
import ConfimDialog from "components/confirmDialog/confirmDialog";
import Http404 from "layouts/error/404";
import PageLayout from "components/LayoutContainers/PageLayout";
import DrawerComponent from "components/drawer/drawer";
import Enrollment from "layouts/enrollment/newEnrollment";
import Http403 from "layouts/error/403";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userData } from "schemas";
import Settings from "layouts/settings/settings";
import RedirectComponent from "layouts/authentication/redirect/reditect";
import { DrawerSchema } from "schemas";
import { locais } from "schemas";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { getLayoutByDevice } from "hooks/mobileCheck/useCheckMobile";

export default function App() {
  const isMobile = getLayoutByDevice();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { contextHolder } = Alert
  const { ConfirmContextHoldert } = ConfimDialog
  const setUserData = useSetRecoilState(userData)
  const open = useRecoilValue(DrawerSchema)
  const setLocais = useSetRecoilState(locais)
  const { fetchData } = GeneralFetch()
  const location = new useLocation()

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('uId') != undefined && !['/Unauthenticated', '/sign-in'].includes(location.pathname)) {
      setUserData({ id: sessionStorage.getItem('uId'), acesso: sessionStorage.getItem('acesso') })
      fetchData('', 'locais', 'get', 'locais').then((resp) => {
        setLocais(resp?.locais?.map(x => { return { value: x.id, label: x.local } }))
      })
    }
  }, [])

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {contextHolder}
      {ConfirmContextHoldert}
      <Alert />
      <ConfimDialog />
      {open?.open && <DrawerComponent />}

      {(layout === "dashboard" && window.location.hash != '/' && window.location.hash != '#/sign-in') && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName="Material Dashboard 2"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
        </>
      )}

      <Routes>
        {getRoutes(routes)}
        <Route exact path={'/'} element={<Navigate to={'/sign-in'} />} key={'< />'} />;
        <Route exact path={'/sign-in'} element={<SignIn />} key={'<SignIn />'} />;
        {!isMobile && <Route exact path={'/check-noticed-event'} element={<RedirectComponent />} key={'< RedirectComponent/>'} />};
        {sessionStorage.getItem('acesso') === '3' && !isMobile && <Route exact path={'/settings'} element={<Settings />} key={'<Settings />'} />}
        {(sessionStorage.getItem('acesso') && sessionStorage.getItem('acesso') !== '1' && !isMobile) && <Route exact path={'/registar'} element={<Enrollment />} key={'registar'} />}
        <Route path="/Unauthenticated" key={"Unauthenticated"} element={
          <PageLayout>
            <Http403 />
          </PageLayout>
        } />

        <Route path="*" element={
          <PageLayout>
            <Http404 />
          </PageLayout>
        } />
      </Routes>
    </ThemeProvider>
  );
}
